import { ProductPlan } from '../models';

const getRecommendedPlanIdx = (unitCount: number, minUnitCounts: number[]) => {
  const len = minUnitCounts.length - 1;

  return (
    len -
    minUnitCounts
      .reverse()
      .findIndex((minUnitCount) => unitCount > minUnitCount)
  );
};

export const getRecommendedPlanName = (
  unitCount: number,
  productPlans: ProductPlan[]
) => {
  const recommendedPlanIdx = getRecommendedPlanIdx(
    unitCount,
    productPlans.map(
      (productPlan) => productPlan.requiredMinUnitCountForRecommendation
    )
  );

  return productPlans[recommendedPlanIdx]?.planName ?? '';
};
